import type { DisplayState } from './displayTypes';
import {
  DISPLAY_FETCH_REQUEST, DISPLAY_FETCH_SUCCESS, DISPLAY_FETCH_FAILURE,
  DISPLAY_SAVE_REQUEST, DISPLAY_SAVE_SUCCESS, DISPLAY_SAVE_FAILURE,
  DISPLAY_ITEM_DELETE, DISPLAY_SET_EDITING_ID,
  DISPLAY_TOAST_ADD, DISPLAY_TOAST_REMOVE,
} from './displayTypes';

const initialState: DisplayState = {
  items: [],
  loading: false,
  saving: false,
  error: null,
  loadedLocationId: null,
  editingItemId: null,
  editingMediaId: null,
  toasts: [],
};

export function displayReducer(state = initialState, action: any): DisplayState {
  switch (action.type) {
    case DISPLAY_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case DISPLAY_FETCH_SUCCESS:
      return { ...state, loading: false, items: action.payload.items, loadedLocationId: action.payload.locationId };
    case DISPLAY_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DISPLAY_SAVE_REQUEST:
      return { ...state, saving: true, error: null };
    case DISPLAY_SAVE_SUCCESS: {
      const saved = action.payload;
      const exists = state.items.some((i) => i.id === saved.id);
      const nextItems = exists
        ? state.items.map((i) => (i.id === saved.id ? saved : i))
        : [...state.items, saved];
      return { ...state, saving: false, items: nextItems };
    }
    case DISPLAY_SAVE_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case DISPLAY_ITEM_DELETE: {
      const nextItems = state.items.filter((i) => i.id !== action.payload);
      return { ...state, items: nextItems };
    }

    case DISPLAY_SET_EDITING_ID: {
      const payload = action.payload;
      if (payload && typeof payload === 'object') {
        return { ...state, editingItemId: payload.id, editingMediaId: payload.mediaId ?? null };
      }
      return { ...state, editingItemId: payload, editingMediaId: null };
    }

    case DISPLAY_TOAST_ADD:
      return { ...state, toasts: [...state.toasts, action.payload] };
    case DISPLAY_TOAST_REMOVE:
      return { ...state, toasts: state.toasts.filter((t) => t.id !== action.payload) };

    default:
      return state;
  }
}
